import { Plus, X } from 'lucide-react';

// 27/10/2026 (André): compra que veio em mais de uma nota (colchonetes de Osasco, NFs 67871 e
// 67870). O campo "Nº Nota Fiscal" ganha um "+" para cada nota ficar numa linha; o valor segue
// texto, gravado como "67871, 67870". O servidor (_numeros_nf) cria uma OC por nota e o
// lançamento casa cada nota com a sua OC.

// mesmos separadores do servidor: vírgula seguida de espaço, ";", "+", " e ", quebra de linha
const SEPARADOR = /\s*(?:[;+\n]|,\s+|\s+e\s+)\s*/i;

export const ehCampoNumeroNf = (nome?: string) => {
  const n = String(nome || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  return /^n[º°o]?\.?\s*(da\s+)?nota\s+fiscal$/.test(n) || /^numero\s+da\s+nota(\s+fiscal)?$/.test(n);
};

interface Props {
  valor: string;
  onChange: (valor: string) => void;
}

export default function CampoNumerosNf({ valor, onChange }: Props) {
  const partes = String(valor || '').split(SEPARADOR);
  const linhas = partes.length ? partes : [''];
  const gravar = (novas: string[]) => onChange(novas.join(', '));

  return (
    <div className="space-y-1">
      {linhas.map((linha, i) => (
        <div key={i} className="flex items-center gap-1">
          <input
            type="text"
            value={linha}
            placeholder={i === 0 ? 'Número da nota' : 'Número da outra nota'}
            onChange={(e) => {
              const novas = [...linhas];
              // vírgula, ";" ou "+" digitados aqui viram linha nova, não texto da nota
              novas.splice(i, 1, ...e.target.value.split(SEPARADOR));
              gravar(novas);
            }}
            className="flex-1 px-2.5 py-1.5 text-xs border border-gray-300 rounded focus:ring-2 focus:ring-black focus:border-transparent transition-all"
          />
          {linhas.length > 1 && (
            <button
              type="button"
              title="Tirar esta nota"
              onClick={() => gravar(linhas.filter((_, j) => j !== i))}
              className="p-1 text-gray-400 hover:text-red-600 rounded"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          )}
        </div>
      ))}
      <button
        type="button"
        onClick={() => gravar([...linhas, ''])}
        className="inline-flex items-center gap-1 px-2 py-0.5 text-[11px] text-gray-700 border border-dashed border-gray-300 rounded hover:bg-gray-50"
      >
        <Plus className="w-3 h-3" /> Outra nota fiscal
      </button>
      {linhas.filter((l) => l.trim()).length > 1 && (
        <p className="text-[11px] text-gray-500">Uma OC por nota no GIX.</p>
      )}
    </div>
  );
}
